import { HomeRedirect } from '@assets/constants/route-names';

const signInWithGoogle = async () => {
  const encodedURI = encodeURIComponent(HomeRedirect);
  window.location.href = `/login/google-oauth2?next=${encodedURI}`;
};

export { signInWithGoogle };
